export default "__VITE_ASSET__B6dI_0Qz__"